import './ClientAccount.sass'
import ClientAccount from './ClientAccount'

export default ClientAccount
